import { render, staticRenderFns } from "./bind_info.vue?vue&type=template&id=770abc51"
import script from "./bind_info.vue?vue&type=script&lang=js"
export * from "./bind_info.vue?vue&type=script&lang=js"
import style0 from "./bind_info.vue?vue&type=style&index=0&id=770abc51&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports